(function () {
  'use strict';

  var config = window.DharniyaCheckoutConfig || {};
  var countryCode = String(config.countryCode || '').toUpperCase();
  var isIndia = countryCode === 'IN';
  var baseCurrency = 'INR';
  var minimumInrMajor = Number(config.minimumInternationalOrderInr || 4999);
  var minimumInrMinor = Math.round(minimumInrMajor * 100);
  var state = {
    blocked: !isIndia,
    cartCurrency: String(config.marketCurrency || baseCurrency).toUpperCase(),
    thresholdMinor: minimumInrMinor,
    cartTotalMinor: 0
  };

  function getCartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function getShopifyCurrencyRate() {
    var rate = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : null;
  }

  function getThresholdMinor(cartCurrency) {
    var currency = String(cartCurrency || '').toUpperCase();

    if (!currency || currency === baseCurrency) {
      return minimumInrMinor;
    }

    var shopCurrency = String(config.shopCurrency || '').toUpperCase();
    var rate = getShopifyCurrencyRate();

    // Shopify.currency.rate converts the shop currency into the active
    // presentment currency. Dharniya's shop currency is INR.
    if (shopCurrency === baseCurrency && rate) {
      return Math.ceil(minimumInrMajor * rate * 100);
    }

    // Fail closed rather than silently allowing an international checkout
    // when the storefront is in a non-INR currency but no reliable Shopify
    // conversion rate is available.
    return null;
  }

  function formatMoney(minor, currency) {
    if (!Number.isFinite(minor)) return '';

    var code = String(currency || baseCurrency).toUpperCase();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        maximumFractionDigits: code === 'INR' ? 0 : 2
      }).format(minor / 100);
    } catch (error) {
      return (minor / 100).toFixed(2) + ' ' + code;
    }
  }

  function getCheckoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('button[name="checkout"]'));
  }

  function suppressInternationalShiprocket() {
    if (isIndia) return;

    document.querySelectorAll(
      '.shiprocket-headless, .sr-headless-checkout, #fastrr-main-container, [data-fastrr], [id^="fastrr-"]'
    ).forEach(function (element) {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    });
  }

  function updateMinimumMessages(blocked, thresholdMinor, cartTotalMinor, currency, rateUnavailable) {
    var messages = document.querySelectorAll('[data-dharniya-minimum-message]');

    messages.forEach(function (message) {
      var detail = message.querySelector('[data-dharniya-minimum-detail]');
      message.hidden = !blocked;

      if (!blocked || !detail) return;

      if (rateUnavailable) {
        detail.textContent = 'Please refresh the page or select another country/currency before checkout. The ₹4,999 international minimum could not be verified for this currency.';
        return;
      }

      var thresholdLabel = formatMoney(thresholdMinor, currency);
      var remaining = Math.max(0, thresholdMinor - cartTotalMinor);
      var remainingLabel = formatMoney(remaining, currency);

      if (String(currency).toUpperCase() === baseCurrency) {
        detail.textContent = 'Add ' + remainingLabel + ' more in product value to continue to checkout.';
      } else {
        detail.textContent = 'Current minimum in ' + currency + ': ' + thresholdLabel + '. Add ' + remainingLabel + ' more in product value to continue.';
      }
    });
  }

  function applyBlockedState(blocked, thresholdMinor, cartTotalMinor, currency, rateUnavailable) {
    state.blocked = blocked;
    state.thresholdMinor = thresholdMinor || 0;
    state.cartTotalMinor = cartTotalMinor || 0;
    state.cartCurrency = currency || state.cartCurrency;

    document.documentElement.setAttribute('data-dharniya-min-order-blocked', blocked ? 'true' : 'false');

    getCheckoutButtons().forEach(function (button) {
      if (blocked) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.dataset.dharniyaMinimumBlocked = 'true';
      } else if (button.dataset.dharniyaMinimumGate === 'true' || button.dataset.dharniyaMinimumBlocked === 'true') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.dataset.dharniyaMinimumBlocked = 'false';
      }
    });

    updateMinimumMessages(blocked, thresholdMinor, cartTotalMinor, currency, rateUnavailable);
  }

  function evaluateCart() {
    suppressInternationalShiprocket();

    if (isIndia) {
      applyBlockedState(false, minimumInrMinor, 0, baseCurrency, false);
      return Promise.resolve();
    }

    return fetch(getCartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        var currency = String(cart.currency || config.marketCurrency || baseCurrency).toUpperCase();
        var cartTotalMinor = Number(cart.total_price || 0);
        var thresholdMinor = getThresholdMinor(currency);
        var rateUnavailable = thresholdMinor === null;
        var blocked = rateUnavailable || cartTotalMinor < thresholdMinor;

        applyBlockedState(blocked, thresholdMinor, cartTotalMinor, currency, rateUnavailable);
      })
      .catch(function () {
        // If cart validation cannot be evaluated, block international checkout
        // rather than accidentally allowing a below-minimum order.
        applyBlockedState(true, null, 0, state.cartCurrency, true);
      });
  }

  function blockCheckoutEvent(event) {
    if (isIndia || !state.blocked) return;

    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var checkoutTrigger = target.closest(
      'button[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart'
    );

    if (!checkoutTrigger) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    var message = document.querySelector('[data-dharniya-minimum-message]');
    if (message) {
      message.hidden = false;
      message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (isIndia) {
    document.documentElement.setAttribute('data-dharniya-min-order-blocked', 'false');
    return;
  }

  document.addEventListener('click', blockCheckoutEvent, true);
  document.addEventListener('submit', function (event) {
    if (!state.blocked) return;
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var submitter = event.submitter;
    var isCheckoutSubmit = submitter && submitter.getAttribute('name') === 'checkout';
    if (!isCheckoutSubmit) return;

    event.preventDefault();
    event.stopPropagation();
    var message = document.querySelector('[data-dharniya-minimum-message]');
    if (message) message.hidden = false;
  }, true);

  document.addEventListener('cart:update', function () {
    window.setTimeout(evaluateCart, 0);
  });
  document.addEventListener('discount:update', function () {
    window.setTimeout(evaluateCart, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluateCart, { once: true });
  } else {
    evaluateCart();
  }

  // Cart drawer markup can be replaced after an AJAX cart update. Re-apply the
  // current disabled/message state to newly rendered checkout controls.
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === 1 && (
          node.matches && node.matches('.cart__ctas, button[name="checkout"], [data-dharniya-minimum-message]') ||
          node.querySelector && node.querySelector('button[name="checkout"], [data-dharniya-minimum-message]')
        );
      });
    });

    if (!isIndia) suppressInternationalShiprocket();

    if (relevant) {
      applyBlockedState(
        state.blocked,
        state.thresholdMinor,
        state.cartTotalMinor,
        state.cartCurrency,
        state.thresholdMinor === 0 && state.blocked
      );
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
